import { render, staticRenderFns } from "./JoinJciMember.vue?vue&type=template&id=2b95be54"
import script from "./JoinJciMember.vue?vue&type=script&lang=js"
export * from "./JoinJciMember.vue?vue&type=script&lang=js"
import style0 from "./JoinJciMember.vue?vue&type=style&index=0&id=2b95be54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports